export default "__VITE_ASSET__0271df62__"